import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const DairyBasedIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600" {...rest}>
      <defs>
        <style
          dangerouslySetInnerHTML={{
            __html: `.cls-dairy-1,.cls-dairy-3,.cls-dairy-5,.cls-dairy-6{fill:none;}.cls-dairy-2{clip-path:url(#clip-path-dairy);}.cls-dairy-3,.cls-dairy-5,.cls-dairy-6{stroke:${color};stroke-miterlimit:10;}.cls-dairy-3{stroke-width:15px;}.cls-dairy-4{clip-path:url(#clip-path-dairy-2);}.cls-dairy-5,.cls-dairy-6{stroke-width:20px;}.cls-dairy-6{stroke-linecap:round;}`,
          }}
        ></style>
        <clipPath id="clip-path-dairy">
          <rect className="cls-dairy-1" x="299.83" y="306.18" width="84.13" height="147.17" />
        </clipPath>
        <clipPath id="clip-path-dairy-2">
          <rect className="cls-dairy-1" x="216.04" y="306.18" width="84.13" height="147.17" />
        </clipPath>
      </defs>
      <g id="_Gespiegelt_wiederholen_" data-name="&lt;Gespiegelt wiederholen&gt;">
        <g className="cls-dairy-2">
          <path
            className="cls-dairy-3"
            d="M300,326.68c1,0,6.27-.69,6.63-1.57a62.3,62.3,0,0,1,2.81-6.36A9.09,9.09,0,0,1,320,313.94a8.42,8.42,0,0,1,5.75,4.3,57,57,0,0,1,3,6.42,13.11,13.11,0,0,0,4.67,6.09c2.29,1.63,7.42,4.24,8.14,3.39a20.91,20.91,0,0,1,15.84-7.77c3.06-.09,6.14-.08,9.2,0a9.71,9.71,0,0,1,9.7,9c.35,3.7.33,7.44-1.31,10.9-3.13,6.58-8.39,9.9-15.67,10-4.79,0-15,2-16.11,3.57-5.51,7.84-.1,17.56-.15,27.14a24.05,24.05,0,0,1-3.75,12.76c-1.9,3.09-3.77,6.2-5.72,9.26a2.84,2.84,0,0,0-.3,2.47,22.67,22.67,0,0,1,1.51,6,107.39,107.39,0,0,1,0,12.3,15.75,15.75,0,0,1-13.94,14.76,151.59,151.59,0,0,1-20.8,1.44"
          />
        </g>
      </g>
      <g id="_Gespiegelt_wiederholen_2" data-name="&lt;Gespiegelt wiederholen&gt;">
        <g className="cls-dairy-4">
          <path
            className="cls-dairy-3"
            d="M300,326.68c-1,0-6.27-.69-6.63-1.57a62.3,62.3,0,0,0-2.81-6.36A9.09,9.09,0,0,0,280,313.94a8.42,8.42,0,0,0-5.75,4.3,57,57,0,0,0-3,6.42,13.11,13.11,0,0,1-4.67,6.09c-2.29,1.63-7.42,4.24-8.14,3.39a20.91,20.91,0,0,0-15.84-7.77c-3.06-.09-6.14-.08-9.2,0a9.71,9.71,0,0,0-9.7,9c-.35,3.7-.33,7.44,1.31,10.9,3.13,6.58,8.39,9.9,15.67,10,4.79,0,15,2,16.11,3.57,5.51,7.84.1,17.56.15,27.14a24.05,24.05,0,0,0,3.75,12.76c1.9,3.09,3.77,6.2,5.72,9.26a2.84,2.84,0,0,1,.3,2.47,22.67,22.67,0,0,0-1.51,6,107.39,107.39,0,0,0,0,12.3,15.75,15.75,0,0,0,13.94,14.76,151.59,151.59,0,0,0,20.8,1.44"
          />
        </g>
      </g>
      <path
        className="cls-dairy-5"
        d="M423,267V481.86a46.42,46.42,0,0,1-46.42,46.42H223.41A46.42,46.42,0,0,1,177,481.86V267a76,76,0,0,1,34.57-63.72l18.2-11.84a41.46,41.46,0,0,0,18.86-34.75V115.8H351.38v40.91a41.46,41.46,0,0,0,18.86,34.75l18.2,11.84A76,76,0,0,1,423,267Z"
      />
      <path
        className="cls-dairy-5"
        d="M377.6,91.19A24.62,24.62,0,0,1,353,115.8H247a24.61,24.61,0,0,1,0-49.22H353A24.61,24.61,0,0,1,377.6,91.19Z"
      />
      <path
        className="cls-dairy-6"
        d="M179.21,255.87c21.69-.92,43.19-23.57,90.08-13.44C303,249.72,326.72,268,356.75,273c35.2,5.91,54.88-3.81,65.8-14.29"
      />
    </svg>
  );
};
